<template>
  <div class="otherbox">
    <base-header v-if="showType" activeIndex="0" />

    <div :class="showType ? 'banner__layer' : 'banner__layer bannerss'">

      <img class="banner-img" src="@/assets/imgs/about/banner.png" />
      <img class="banner-imgs" src="@/assets/imgs/about/wap/banner.png" />

      <div :class="showType ? 'banner-content content-box' : 'banner-content content-box banner-co'">
        <h1 class="title">稳健企业 焕发新生</h1>
        <h1 class="titles">稳健企业 </h1>
        <h1 class="titles"> 焕发新生</h1>
        <p class="banner-content-intro">香港黄金交易所AA类行员（081号）</p>
        <div class="banner-content-download">
          <router-link to="/Appdownload?key=1">
            <span class="banner-content-download-btn">APP下载</span>
          </router-link>
          <div class="banner-content-download-text">
            <div>
              <img src="@/assets/imgs/about/mobie-icon.png" alt="">
              <span>
                支持多平台 <br />
                双端互通
              </span>
            </div>
            <div>
              <img src="@/assets/imgs/about/user-black-icon.png" alt="">
              <span>
                简单 <br />
                易用
              </span>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="contents">
      <h2>{{ data.title }}</h2>
      <span>{{ data.dt }}</span>
      <hr>
      <div class="content" v-html="data.content"></div>
    </div>
    <base-footer v-if="showType"  />

  </div>
</template>

<script>
import BaseHeader from '@/component/base-header';
import BaseFooter from '@/component/base-footer';
import { postCmsSystemRelay } from '@/apis/transfer';

export default {
  name: 'NoticeDetails',
  components: {

    BaseHeader,
    BaseFooter
  },
  data() {
    return {
      // 父级页面传来的参数
      query: {
        id: '',
      },
      // 获取到的数据
      data: {

      },
      showType: true
    }
  },
  created() {
    if (this.$route.query.from) {
      this.showType = false

    };
    // 传参控制显示顶部和底部
    this.$emit('controlShow', false);

    // 获取参数
    this.query.id = this.$route.query.id;
    // 初始化数据
    this.init(this.query);
  },
  methods: {
    init(attr) {
      postCmsSystemRelay('noticeDetailApi', attr).then(res => {
        this.data = res
      }).catch(err => {
     
      })
    }
  }
}
</script>

<style lang="less">
.otherbox {

  .banner__layer {
    position: relative;
    padding-top: 80px;

    .banner-img {
      width: 100%;
      display: block;
    }

    .banner-imgs {
      display: none;
      width: 100%;
      height: auto;
    }

    .banner-content {
      position: absolute;
      top: 50%;
      left: 30%;
      transform: translate(-50%, -50%);
      z-index: 11;
      color: #FFFFFF;

      .title {
        display: block;
      }

      .titles {
        display: none;
      }

      h1 {
        font-size: 68px;
        margin: 0;
      }

      &-intro {
        font-size: 18px;
      }

      &-download {
        display: flex;
        align-items: center;
        margin-top: 50px;

        &-btn {
          width: 198px;
          line-height: 56px;
          color: #FFFFFF;
          background: #FA2314;
          border-radius: 4px;
          margin-right: 10px;
          cursor: pointer;
          text-align: center;
          font-size: 20px;
          font-weight: 700;
          display: inline-block;
        }

        &-text {
          display: flex;
          align-items: center;

          >div {
            display: flex;
            align-items: center;
            color: #FFFFFF;
            padding: 4px 40px;

            &:first-child {
              border-right: 1px solid #0F0F11;
            }

            img {
              width: 38px;
              height: 38px;
              margin-right: 12px;
            }
          }
        }
      }
    }
  }

  .contents {
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 0px 0 50px;
    align-items: center;
    justify-content: center;
  }

  h2 {
    margin-top: 50px;
  }

  hr {
    width: 950px;
    margin: 20px 0 10px;
  }

  .content {
    width: 950px;

    p {
      margin: 20px 0;

      img {
        margin: 0 auto;
      }
    }
  }

  .bottomSpan {
    font-size: 14px;
  }
}

@media screen and (max-width: 500px) {
  .otherbox {
    .contents {
      padding: 0px 0 30px;
    }

    .banner__layer {

      padding-top: 45px;

      .banner-img {
        display: none;
      }

      .banner-imgs {
        display: block;
        height: 500px;

      }

      .banner-content {
        position: absolute;
        top: 37%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 11;
        padding-top: 40px;
        background: linear-gradient(180deg, #100005 68.28%, rgba(24, 24, 24, 0) 100%);
        // color: #000;
        color: #FFFFFF;

        .title {
          display: none;
        }

        .titles {
          color: #FFFFFF;
          display: block;
          white-space: nowrap;
        }

        h1 {
          font-size: 58px;
          line-height: 77px;
          margin: 0;
          width: 100%;
          text-align: center;
          white-space: wrap;
        }

        &-intro {
          font-size: 14px;
          text-align: center;
        }

        &-download {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 20px;

          &-btn {
            width: 180px;
            line-height: 34px;
            color: #FFFFFF;
            background: #FA2314;
            border-radius: 4px;
            margin-right: 10px;
            cursor: pointer;
            text-align: center;
            font-size: 14px;
            font-weight: 700;
            margin-bottom: 20px;
          }

          &-text {
            display: flex;
            align-items: center;

            >div {
              display: flex;
              align-items: center;
              color: #0F0F11;
              color: #FFFFFF;

              padding: 2px 20px;
              font-size: 10px;

              &:first-child {
                border-right: 1px solid #fff;
              }

              img {
                width: 24px;
                height: 24px;
                margin-right: 12px;
              }
            }
          }
        }
      }
            .banner-co {
              top: 33%;
            }
    }
 .bannerss {
   padding-top: 0;
 }
    .content-box {
      width: 100%;
      margin: auto;
      box-sizing: border-box;
    }

    h2 {
      margin-top: 30px;
      font-size: 22px;
      text-align: center;
    }

    hr {
      width: 95%;
      margin: 20px 0 10px;
    }

    .content {
      width: 95%;
      margin: 0 auto;

      p:nth-child(1) {
        font-size: 14px !important;
      }

      p {
        margin: 5px 0;

        img {
          width: 100% !important;
          margin: 0 auto;
        }
      }
    }

    .bottomSpan {
      font-size: 14px;
      margin-top: 20px;
      width: 95%;

    }
  }
}
</style>
